import CircularProgress from '@ahamove/web-components/lib/CircularProgress';
import Divider from '@ahamove/web-components/lib/Divider';
import type { ListItemProps } from '@ahamove/web-components/lib/ListItem';
import ListItem from '@ahamove/web-components/lib/ListItem';
import ListItemAvatar from '@ahamove/web-components/lib/ListItemAvatar';
import ListItemButton from '@ahamove/web-components/lib/ListItemButton';
import ListItemText from '@ahamove/web-components/lib/ListItemText';
import React from 'react';
import type { Address } from '@/api/place/types';
import { PointItemIcon } from '@/lib/icons';

type Props = {
  address: Address | null;
  loading?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  divider?: boolean;
} & ListItemProps;

export default function LocationItem({
  address,
  loading = false,
  onClick,
  sx,
  divider = false,
  ...props
}: Props) {
  if (!address) return <React.Fragment />;

  return (
    <>
      <ListItem sx={{ ...sx, bgcolor: 'common.white' }} {...props}>
        <ListItemButton
          sx={{ pr: '16px !important' }}
          disableRipple
          disabled={loading}
          onClick={onClick}
          data-test-id="locationItem"
        >
          <ListItemAvatar sx={{ minWidth: 40 }}>
            {loading ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              <PointItemIcon />
            )}
          </ListItemAvatar>
          <ListItemText
            primary={
              address.short_address ||
              `${address.address}`.substring(
                0,
                `${address.address}`.indexOf(',')
              )
            }
            primaryTypographyProps={{
              variant: 'h6',
              color: 'grey.900',
            }}
            secondary={address.address}
            secondaryTypographyProps={{
              variant: 'caption',
              color: 'grey.700',
              fontWeight: 500,
              noWrap: true,
            }}
          />
        </ListItemButton>
      </ListItem>
      {divider ? <Divider variant="inset" sx={{ ml: 7.5 }} /> : null}
    </>
  );
}
